/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  InvestorProfileResult,
  Questions,
  UserAnswersRequest,
} from '../models/index';
import {
    InvestorProfileResultFromJSON,
    InvestorProfileResultToJSON,
    QuestionsFromJSON,
    QuestionsToJSON,
    UserAnswersRequestFromJSON,
    UserAnswersRequestToJSON,
} from '../models/index';

export interface PostInvestorProfilePostRequest {
    userAnswersRequest: UserAnswersRequest;
}

/**
 * 
 */
export class InvestorProfileApi extends runtime.BaseAPI {

    /**
     * Get questions for investment profile
     */
    async getInvestorProfileQuestionsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Questions>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"]);
        }

        const response = await this.request({
            path: `/investor-profile/questions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(QuestionsFromJSON));
    }

    /**
     * Get questions for investment profile
     */
    async getInvestorProfileQuestionsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Questions>> {
        const response = await this.getInvestorProfileQuestionsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Resolve answers for investment profile questions
     */
    async postInvestorProfilePostRaw(requestParameters: PostInvestorProfilePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvestorProfileResult>> {
        if (requestParameters['userAnswersRequest'] == null) {
            throw new runtime.RequiredError(
                'userAnswersRequest',
                'Required parameter "userAnswersRequest" was null or undefined when calling postInvestorProfilePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"]);
        }

        const response = await this.request({
            path: `/investor-profile`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserAnswersRequestToJSON(requestParameters['userAnswersRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvestorProfileResultFromJSON(jsonValue));
    }

    /**
     * Resolve answers for investment profile questions
     */
    async postInvestorProfilePost(requestParameters: PostInvestorProfilePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvestorProfileResult> {
        const response = await this.postInvestorProfilePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
